import {OauthService} from './oauth.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {Http} from '@angular/http';
import {App} from 'ionic-angular';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class PaylineService extends OauthService {

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
  }


  /**
   * Capture
   */
  shouldCapture(token: string, paiementId: string): Observable<any> {
    const param = {'_format': 'json'};
    param['paylinetoken'] = token;
    param['paiementId'] = paiementId;

    const url = this.Routing.generate('api_post_paiement_capture_payline', param, true);

    return this.http.post(url, null, {headers: this.updateHeaders()}).map(response => response.json().data);
  }

}



// WEBPACK FOOTER //
// ./src/shared/services/payline.service.ts